import {
	FrontendCompanyWithAdditionalInfomation,
	FrontendUserInfo,
} from "node-library/dist/portal";
import { useTranslation } from "react-i18next";

import { ONE_DAY_IN_MS } from "node-library/dist/constants";

import { SemanticColor } from "node-library/dist/colors";

import { formatCustomDate } from "node-library/dist/helpers/date_helper";

import { FrontendSampleTestBatchOverview } from "node-library/dist/structures/frontendSampleTestBatchPageDefinitions";
import {
	findCompanyBatchTypeById,
	getBatchStatusColors,
	getBatchStatusTranslationString,
} from "../../../../helpers/testBatchHelper";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	batchOverview: FrontendSampleTestBatchOverview;
	user: FrontendUserInfo | undefined;
	goToViewBatchDetails: () => void;
}

export default function AnalystViewBatchRow(props: Props) {
	const { t: translation } = useTranslation();

	const { company, batchOverview, user, goToViewBatchDetails } = props;

	const statusString: string = getBatchStatusTranslationString(
		batchOverview.batchStatus,
		translation
	);
	const statusColor: {
		backgroundColor: string;
		borderColor: string;
		textColor: string;
	} = getBatchStatusColors(batchOverview.batchStatus);

	const currDate: Date = new Date();
	const dueDate: Date = new Date(batchOverview.dueDate as Date);
	const dueDateString: string = formatCustomDate(dueDate);

	const remainingTimeInMillis =
		dueDate.getTime() - currDate.getTime() - ONE_DAY_IN_MS;
	const dueDateWarning: boolean = remainingTimeInMillis <= 0;

	const isOtherTestBatch: boolean = batchOverview.isOtherTestBatch;

	const batchRowItem: React.ReactNode = (
		<div
			key={batchOverview.testBatchId}
			className="analyst-batch-list-view-row batch-list-view-item-row typography-body-01"
			onClick={() => {
				goToViewBatchDetails();
			}}
		>
			<div
				className={`${
					dueDateWarning ? `typography-bold` : ``
				} batch-list-view-row-id-section batch-list-view-row-item`}
			>
				{dueDateWarning && (
					<span
						style={{
							width: "8px",
							height: "8px",
							borderRadius: "50%",
							backgroundColor: SemanticColor.ERROR,
						}}
					></span>
				)}
				{batchOverview.batchFullCode}
			</div>
			<div className="batch-list-view-row-item">
				{isOtherTestBatch
					? translation("Other")
					: findCompanyBatchTypeById(
							company,
							batchOverview.mainTestCategoryId,
							batchOverview.batchTypeId || ""
					  )?.batchName}
			</div>
			<div className="batch-list-view-row-item">
				{batchOverview.testMethodCode}
			</div>
			<div className="batch-list-view-row-item">{batchOverview.batchSize}</div>
			<div className="batch-list-view-row-item">
				{batchOverview.assignedUserFullName}
			</div>
			<div className="instance-list-view-row-item">
				{dueDateString.split(" | ")[0]}
			</div>
			<div className="instance-list-view-row-item">
				<div
					className="typography-caption admin-sample-status-box admin-status-box-medium"
					style={{
						backgroundColor: statusColor.backgroundColor,
						border: `1px solid ${statusColor.borderColor}`,
						color: statusColor.textColor,
					}}
				>
					{statusString}
				</div>
			</div>
		</div>
	);

	return batchRowItem;
}
